import type { ReactNode } from 'react';
import { Card, CardBody, CardHeader, Flex, Link, Text } from '@backstage/ui';

type InsightsCardShellProps = {
  teamLabel?: string;
  insightsHref?: string;
  children: ReactNode;
};

export const InsightsCardShell = ({
  teamLabel,
  insightsHref,
  children,
}: InsightsCardShellProps) => (
  <Card>
    <CardHeader>
      <Flex align="center" justify="between" gap="2" p="1">
        <Text variant="title-x-small" weight="bold">
          Pulse Insights
          <Text variant="title-x-small"> for {teamLabel ?? 'your team'}</Text>
        </Text>
        {insightsHref && (
          <Link href={insightsHref} variant="body-small">
            View insights in detail
          </Link>
        )}
      </Flex>
    </CardHeader>
    <CardBody>{children}</CardBody>
  </Card>
);
